<template>
  <div>
    <div>
      <b-form
        class="input-password-form input-password-form-black custom-input-form preview"
        aria-live="assertive"
      >
        <b-form-group
          class="my-4"
          label-class="text-muted mb-2"
          :label="$t('form.oldPassword.label')"
          label-for="input-old-password"
          :state="validateState('oldPassword')"
          :invalid-feedback="$t('message.error.requiredField')"
        >
          <b-input-group>
            <b-form-input
              id="input-old-password"
              ref="oldPassword"
              v-model="form.oldPassword"
              :type="passwordFieldType"
              :state="validateState('oldPassword')"
              aria-describedby="input-password-feedback"
              placeholder="********"
              class="custom-form-input custom-form-input-class text-muted"
            ></b-form-input>
            <b-input-group-append>
              <b-button class="preview-icon d-flex align-items-center" @click="showPwd">
                <svg-icon
                  v-show="!showPassword"
                  class="fill-icon show-icon"
                  name="close-eye"
                  size="20"
                ></svg-icon>
                <svg-icon
                  v-show="showPassword"
                  class="fill-icon show-icon"
                  name="open-eye"
                  size="20"
                ></svg-icon>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-email-feedback">
              {{ $t('message.error.requiredField') }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>

        <b-form-group
          class="my-4"
          label-class="text-muted mb-2"
          :label="$t('form.newPassword.label')"
          label-for="input-new-password"
          :state="validateState('newPassword')"
          :invalid-feedback="$t('message.error.requiredField')"
        >
          <b-input-group>
            <b-form-input
              id="input-new-password"
              ref="newPassword"
              v-model="form.newPassword"
              :type="passwordFieldType"
              aria-describedby="input-password-feedback"
              placeholder="********"
              class="custom-form-input custom-form-input-class text-muted"
              :state="validateState('newPassword')"
            ></b-form-input>
            <b-input-group-append>
              <b-button class="preview-icon d-flex align-items-center" @click="showPwd">
                <svg-icon
                  v-show="!showPassword"
                  class="fill-icon show-icon"
                  name="close-eye"
                  size="20"
                ></svg-icon>
                <svg-icon
                  v-show="showPassword"
                  class="fill-icon show-icon"
                  name="open-eye"
                  size="20"
                ></svg-icon>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-email-feedback">
              {{ $t('message.error.requiredField') }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group
          class="my-4"
          label-class="text-muted mb-2"
          :label="$t('form.newPassword2.label')"
          label-for="input-new-password2"
          :state="validateState('newPassword2')"
          :invalid-feedback="$t('message.error.passwordsMatch')"
        >
          <b-input-group>
            <b-form-input
              id="input-new-password2"
              ref="newPassword2"
              v-model="form.newPassword2"
              :type="passwordFieldType"
              aria-describedby="input-password-feedback"
              placeholder="********"
              class="custom-form-input custom-form-input-class text-muted"
              :state="validateState('newPassword2')"
            ></b-form-input>
            <b-input-group-append>
              <b-button class="preview-icon d-flex align-items-center" @click="showPwd">
                <svg-icon
                  v-show="!showPassword"
                  class="fill-icon show-icon"
                  name="close-eye"
                  size="20"
                ></svg-icon>
                <svg-icon
                  v-show="showPassword"
                  class="fill-icon show-icon"
                  name="open-eye"
                  size="20"
                ></svg-icon>
              </b-button>
            </b-input-group-append>
            <b-form-invalid-feedback id="input-email-feedback">
              {{ $t('message.error.requiredField') }}
            </b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
      </b-form>
    </div>
    <div class="d-flex justify-content-between my-5 pt-3">
      <b-btn variant="transparent" class="btn-icon-text" size="lg" @click="onClose">
        {{ $t('button.cancel.label') }}
      </b-btn>
      <b-btn size="lg" class="btn-icon-text" variant="primary" @click="onOk">
        {{ $t('button.save.label') }}
      </b-btn>
    </div>
  </div>
</template>

<script>
import { required, sameAs } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';

import changePasswordMutation from '@/api/user/mutations/changePassword.gql';

export default {
  name: 'PasswordPopover',
  mixins: [validationMixin],
  data() {
    return {
      showPassword: false,
      popoverShow: false,
      form: {
        oldPassword: '',
        newPassword: '',
        newPassword2: '',
      },
    };
  },
  validations: {
    form: {
      oldPassword: {
        required,
      },
      newPassword: {
        required,
      },
      newPassword2: {
        required,
        sameAsPassword: sameAs('newPassword'),
      },
    },
  },
  computed: {
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    },
  },
  methods: {
    showPwd() {
      this.showPassword = !this.showPassword;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onClose() {
      this.$emit('editPasswordClose');
    },
    onOk() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.$apollo
        .mutate({
          mutation: changePasswordMutation,
          variables: {
            oldPassword: this.form.oldPassword,
            newPassword: this.form.newPassword,
          },
          refetchQueries: [],
        })
        .then(() => {
          this.$bvToast.toast(this.$t('form.toast.passSave'), {
            title: this.$t('toast.success'),
            variant: 'success',
            solid: true,
          });
        })
        .catch((e) => {
          this.$bvToast.toast(this.$t('form.toast.passNotSave'), {
            title: this.$t('toast.error'),
            variant: 'danger',
            solid: true,
          });
          console.log(e.message);
        });
      this.onClose();
    },
    onShow() {
      this.form = {
        oldPassword: '',
        newPassword: '',
        newPassword2: '',
      };
      this.$v.form.$reset();
    },
    onShown() {
      this.focusRef(this.$refs.oldPassword);
    },
    focusRef(ref) {
      this.$nextTick(() => {
        this.$nextTick(() => {
          (ref.$el || ref).focus();
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
